module.exports = __webpack_public_path__ + "static/img/B (7).63f81491.png";